import styled from '@emotion/styled'
import { animated } from 'react-spring'
import { at } from '../../../styles/utils'
import { breakpoints, spacing } from '../../../styles/vars'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  .chart {
    position: relative;
  }

  svg {
    display: block;
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};
    background: #000;
  }
`

export const CounterWrapper = styled.div`
  position: absolute;
  left: ${spacing.mobile};

  &.top {
    top: ${spacing.mobile};
  }
  &.bottom {
    bottom: ${spacing.mobile};
  }
  [lang='ar'] & {
    right: ${spacing.mobile};
    left: auto;
  }
  ${at(breakpoints.desktop)} {
    left: ${spacing.desktop};
    &.top {
      top: ${spacing.desktop};
    }
    &.bottom {
      bottom: ${spacing.desktop};
    }
    [lang='ar'] & {
      right: ${spacing.desktop};
      left: auto;
    }
  }
`

export const CounterLabel = styled.h2`
  font-size: 1em;
  margin-bottom: 0.5em;
`

export const CounterValue = styled(animated.h2)`
  font-size: 2em;
`
